module.exports = __webpack_public_path__ + "img/IdeasFundX_consultancy.2be6f628.png";